import { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import Application from "services/applications/Application.service"
const appService = new Application(JSON.parse(localStorage.getItem("authUser")))

const Decisions = props => {
  const [officerDecision, setofficerDecision] = useState()
  const [headDecision, setheadDecision] = useState()
  const [directorDecision, setdirectorDecision] = useState()
  const [badge, setbadge] = useState()
  const [inspectionReportAvailable, setinspectionReportAvailable] =
    useState(false)


  useEffect(() => {
    // console.log("app details => ", props.appDetails)
    // console.log("status ID  => ", props.appDetails.application_status_id)
    if (props.appDetails.application_status_id > 3) {
      fetchOfficerDecision({
        application_id: props.appDetails.id,
        staff_id: props.appDetails.application_assignment.staff_id,
        name:
          props.appDetails.application_assignment.staff.first_name +
          " " +
          props.appDetails.application_assignment.staff.last_name,
      })
      fetchHeadDecision(props.appDetails.id)
      fetchDirectorDecision(props.appDetails.id)
      // console.log("app details", props.appDetails)

      // Is inspection report available?
      if (props.appDetails?.inspection_report) {
        if (props.appDetails.inspection_report != null) {
          setinspectionReportAvailable(true)
        }
      }
    }

    // badges
    if (props.appDetails.application_status_id === 6) {
      setbadge("alert alert-success")
    } else if (props.appDetails.application_status_id === 7) {
      setbadge("alert alert-warning")
    } else if (props.appDetails.application_status_id === 9) {
      setbadge("alert alert-danger")
    } else {
      setbadge("alert alert-info")
    }
  }, [])

  const fetchOfficerDecision = input => {
    let officer = input.name
    appService.getOfficerReviewDetails(input).then(response => {
      // console.log("Get Officer Review", response)
      if (response.status) {
        setofficerDecision(
          <ReviewRow
            class_name=""
            reason={response.data.reason}
            status={response.data.decision}
            reviewer={officer}
          />
        )
      }
    })
  }

  const fetchHeadDecision = application_id => {
    appService.getHoDReviewDetails(application_id).then(response => {
      // console.log("Get HOD Review", response.data)
      if (response.status && props.appDetails.application_status_id >= 5) {
        setheadDecision(
          <ReviewRow
            class_name=""
            reason={response.data.reason}
            status={response.data.decision}
            reviewer={"HoD"}
          />
        )
      }
    })
  }

  const fetchDirectorDecision = application_id => {
    appService.getDirectorReviewDetails(application_id).then(response => {
      // console.log("Get Director General Review", response)
      if (response.status && response.data != null) {
        setdirectorDecision(
          <ReviewRow
            class_name=""
            reason={response.data.reason}
            status={response.data.decision}
            reviewer={"Director"}
          />
        )
      }
    })
  }

  const download = (path, name) => {
    appService
      .downloadAttachment(path)
      .then(response => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", name)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <>
      <Card>
        <CardHeader className={badge}>Decisions</CardHeader>
        <CardBody>
          <Row>
            <Col md={3}>
              <span>Status</span>
            </Col>
            <Col md={6}>
              <span>Reason</span>
            </Col>
            <Col md={3}>Reviewer</Col>
          </Row>
          <div>{officerDecision}</div>
          <hr></hr>
          <div>{headDecision}</div>
          <hr></hr>
          <div>{directorDecision}</div>

          {inspectionReportAvailable ? (
            <div>
              <hr></hr>
              <h6>Inspection Report</h6>
              <h6>
                <a
                  href="#"
                  onClick={e =>
                    download(
                      props.appDetails.inspection_report.path,
                      props.appDetails.inspection_report.file_name
                    )
                  }
                >
                  Download Inspection Report{" "}
                  <i
                    className="fas fa-cloud-download-alt"
                    title="Download"
                    style={{ color: "green" }}
                  ></i>
                </a>
              </h6>
            </div>
          ) : null}
        </CardBody>
      </Card>
    </>
  )
}

const ReviewRow = props => {
  return (
    <>
      <Row>
        <Col md={3}>
          <span className={props.class_name}>{props.status}</span>
        </Col>
        <Col md={6}>
          <span>{props.reason}</span>
        </Col>
        <Col md={3}>{props.reviewer}</Col>
      </Row>
    </>
  )
}

export default Decisions
